import { NgModule } from '@angular/core';
import { AddressModule } from '../../../../address/address.module';
import { NoteModule } from '../../../../note/note.module';
import { SharedModule } from '../../../../shared/shared.module';
import { OneTimeMailingAddressComponent } from './one-time-mailing-address.component';

@NgModule({
    declarations: [
        OneTimeMailingAddressComponent
    ],
    providers: [],
    imports: [
        SharedModule,
        NoteModule,
        AddressModule
    ],
    exports: [
        OneTimeMailingAddressComponent
    ]
})
export class OneTimeMailingAddressModule {}
